export function setSgaCompleto(state, sgacompleto){
    state.selectedSgaCompletoEt = sgacompleto;
}

export function cambiaIdioma (state, idioma) { 
    state.idioma = idioma;
}

export function cambiaVersion (state, version) {
    state.version = version;
}
export function setClasificacionSGAListas(state, sgaListas){
    state.clasificacionSGAListas.sinSGA = sgaListas[0].lista;
} 